<template lang="html">
 <!-- 操作指引 -->
 <div class="mask">

       <!-- 步骤1 -->
       <div class="step step01" v-if="step==1">
            <div  class="navBtn" :style="{top:curTop+'px'}">
                组织机构
            </div>
            <div class="dirctionBox" :style="{top:curTop+20+'px'}">
              <div>
                  <img src="@static/images/dirction.png" alt="">
              </div>
               <div class="info">组建团队、创立下级机构，管理团队与业务员</div>
               <div class="btns clearfix">
                    <div class="know"  @click="$emit('next',true)">我知道了，马上体验</div>
                     <div class="next"  @click="$emit('next')">下一步（1/7）</div>
               </div>
            </div>
       </div>
        <!-- 步骤2 -->
       <div class="step step02" v-if="step==2">

            <div class="dirctionBox">
              <div>
                  <img src="@static/images/dirction.png" alt="">
              </div>
               <div class="info">点击组织机构树中的某个团队或机构，查看组成</div>
               <div class="btns clearfix">
                    <div class="know"  @click="toggleNext">我知道了，马上体验</div>
                     <div class="next" @click="$emit('next')">下一步（2/7）</div>
               </div>
            </div>
       </div>
       <!-- 步骤3 -->

       <div class="step step03" v-if="step==3">
            <div class="dirctionBox">
              <div class="arrowBox">
                  <img src="@static/images/dirction.png" alt="">
                  <div class="outer">
                      <div  class="btn rightFr">
                    <span  class="icon icon-add02"></span>
                    <span >新增</span>
                   </div>
                  </div>

              </div>
               <div class="info">新增业务员后，业务员会收到一组账号密码<br> 用来登录凤栖出单展业平台</div>
               <div class="btns clearfix">
                    <div class="know"  @click="$emit('next',true)">我知道了，马上体验</div>
                     <div class="next" @click="$emit('next')">下一步（3/7）</div>
               </div>
            </div>
       </div>
          <!-- 步骤4 -->
        <div class="step step04" v-if="step==4">
            <div class="dirctionBox">
              <div class="arrowBox">
                  <img src="@static/images/dirction-2.png" alt="">
                  <div class="outer">
                      <div style="margin-bottom:18px;">
                        <span class="icon icon-pro" style="margin-right:2px;"></span>
                        <span style="color:#236DFF ">ta的产品</span>
                        </div>
                           <div >
                        <span class="icon icon-pro" style="margin-right:2px;"></span>
                        <span style="color:#236DFF ">ta的产品</span>
                        </div>
                  </div>

              </div>
               <div class="info">查看某个业务员可推广的全部产品</div>
               <div class="btns clearfix">
                    <div class="know" @click="$emit('next',true)">我知道了，马上体验</div>
                     <div class="next" @click="$emit('next')">下一步（4/7）</div>
               </div>
            </div>
       </div>
           <!-- 步骤5 -->
        <div class="step step05 step01" v-if="step==5">
           <div  class="navBtn" :style="{top:curTop+'px'}">
                服务费模板
            </div>
            <div class="dirctionBox" :style="{top:curTop+20+'px'}">
              <div class="arrowBox">
                  <img src="@static/images/dirction.png" alt="">


              </div>
               <div class="info">建立服务费模板，可以实现对多个下级机构<br>团队服务费的一键配置</div>
               <div class="btns clearfix">
                    <div class="know" @click="$emit('next',true)">我知道了，马上体验</div>
                     <div class="next" @click="$emit('next')">下一步（5/7）</div>
               </div>
            </div>
       </div>
          <!-- 步骤6 -->
          <div class="step step06 step01" v-if="step==6">
           <div  class="navBtn" :style="{top:curTop+'px'}">
                商城装修
            </div>
            <div class="dirctionBox"  :style="{top:curTop+20+'px'}">
              <div class="arrowBox">
                  <img src="@static/images/dirction.png" alt="">


              </div>
               <div class="info">个性化我的展业平台，助力业务员展业</div>
               <div class="btns clearfix">
                    <div class="know"  @click="$emit('next',true)">我知道了，马上体验</div>
                     <div class="next" @click="$emit('next')">下一步（6/7）</div>
               </div>
            </div>
       </div>
          <!-- 步骤7 -->
          <div class="step step07 step01" v-if="step==7">
             <div  class="navBtn" :style="{top:curTop-50+'px'}">
                财务管理
            </div>
            <div class="dirctionBox"  :style="{top:curTop-30+'px'}">
              <div class="arrowBox">
                  <img src="@static/images/dirction.png" alt="">
              </div>
               <div class="info"> 查看我的、下级机构/团队/业务员的结算费用，机构<br>
                可在此处申请提现，总部可向下进行结算</div>
               <div class="btns clearfix">
                     <div class="next" @click="$emit('next',true)">完成学习，开启展业之路</div>
               </div>
            </div>
       </div>
 </div>
</template>
<script>
import "loaders.css";
export default {
  props: ["step", "curTop"],
  data() {
    return {
      treeDom: null
    };
  },
  methods: {
    toggleNext() {
      document.body.removeChild(this.treeDom);
      this.treeDom = null;
      this.$emit("next");
    }
  },
  watch: {
    step(val) {
      if (val == 3) {
        //切换团队详情
        const iframe = document.getElementById("iframe");
        iframe.contentWindow.postMessage({ changePage: true }, "*");
      }
      if (val == 2) {
        this.$nextTick(() => {
          const iframe = document.getElementById("iframe");
          this.treeDom = iframe.contentWindow.document
            .querySelector(".organize-tree")
            .cloneNode(true);
          this.treeDom.style.height = "auto";
          this.treeDom.classList.add("topPosition");
          //追加机构
          document.body.append(this.treeDom);
        });
      } else {
        //移除机构
        if (document.querySelector(".organize-tree")) {
          document.body.removeChild(this.treeDom);
        }
        this.treeDom = null;
      }
    },
    treeDom(val) {
      if (val) {
        if (this.step == 2) {
          //追加机构
          document.body.append(this.treeDom);
        } else {
          //移除机构
          if (document.querySelector(".organize-tree")) {
            document.body.removeChild(this.treeDom);
            this.treeDom = null;
          }
        }
      }
    }
  },
  mounted() {
    if (document.querySelector(".organize-tree")) {
      document.body.removeChild(document.querySelector(".organize-tree"));
    }
    this.treeDom = null;
    document
      .getElementById("iframe")
      .contentWindow.postMessage({ togglePage: true }, "*");
  }
};
</script>

<style lang="scss" scoped>
.mask {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1000;

  .step {
    color: #fff;
  }
  .step01 {
    .navBtn {
      width: 200px;
      height: 49px;
      line-height: 49px;
      color: #fff;
      border-radius: 0;
      position: absolute;
      top: 159px;
      background: #236dff;
      text-indent: 40px;
    }
    .dirctionBox {
      position: absolute;
      left: 212px;
      top: 180px;
    }
  }
  .step02 {
    position: absolute;
    left: 540px;
    top: 300px;
  }
  .step03 {
    position: absolute;
    right: 280px;
    top: 350px;
    .arrowBox img {
      transform: scaleX(-1) rotate(-45deg);
      position: absolute;
      right: -146px;
      top: -16px;
    }
    .outer {
      background: #fff;
      padding: 10px 16px;
      position: absolute;
      right: -192px;
      top: 54px;
      .rightFr {
        height: 30px;
        width: 100px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #eff4ff;
        border: 1px solid #cadcff;
        opacity: 1;
        border-radius: 4px;
        color: #236dff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .step04 {
    position: absolute;
    right: 300px;
    top: 600px;
    .dirctionBox {
      position: relative;
      left: -50px;
    }
    .arrowBox img {
      position: absolute;
      right: -155px;
      top: -34px;
    }
    .outer {
      background: #fff;

      padding: 10px 16px;
      position: absolute;

      right: -194px;
      top: -85px;
      .rightFr {
        height: 30px;
        width: 100px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        background: #eff4ff;
        border: 1px solid #cadcff;
        opacity: 1;
        border-radius: 4px;
        color: #236dff;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  .step05 {
    .dirctionBox {
      top: 320px;
    }
    .navBtn {
      top: 305px;
    }
  }
  .step06 {
    .dirctionBox {
      top: 372px;
    }
    .navBtn {
      top: 354px;
    }
  }
  .step07 {
    .dirctionBox {
      top: 372px;
    }
    .navBtn {
      top: 354px;
    }
    .btns {
      display: flex;
      justify-content: center;
    }
    .next {
      width: auto !important;
      padding: 0 30px;
    }
  }
  .info {
    color: #fff;
    margin-top: 10px;
    font-size: 18px;
    text-align: center;
  }
  .btns {
    font-size: 14px;
    margin-top: 20px;
    .know {
      float: left;
      width: 186px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      margin-right: 20px;
      &:hover {
        cursor: pointer;
      }
      border-radius: 20px;
      color: #fff;
      border: 1px solid #fff;
    }
    .next {
      float: left;
      &:hover {
        cursor: pointer;
      }
      line-height: 40px;
      text-align: center;
      width: 150px;
      height: 40px;
      background: #ffffff;
      border-radius: 20px;
      color: #236dff;
    }
  }
}
</style>
